const labels = process.env.VUE_APP_LABELS
export default labels ? labels.split(',') : []
